import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BasePricingDetails } from './BasePricingDetails';

export class FlexibleInstallmentPricingDetails extends BasePricingDetails {
  readonly amountToBePaid: number;
  readonly amountToBePaidInLeastSubunit: number;
  readonly minimumDownPaymentAmountToBePaid: number;
  readonly minimumDownPaymentAmountToBePaidInLeastSubunit: number;
  readonly totalPrincipalAmountToBePaid: number;
  readonly totalPrincipalAmountToBePaidInLeastSubunit: number;

  constructor(productDetails: GetProductDetailsResponseType) {
    super(productDetails);

    const customizableDetails =
      productDetails.product_purchase_details_for_user.pricing_details
        .customizable_installment_details;

    this.minimumDownPaymentAmountToBePaid =
      customizableDetails.minimum_down_payment_amount_to_be_paid || 0;
    this.minimumDownPaymentAmountToBePaidInLeastSubunit =
      customizableDetails.minimum_down_payment_amount_to_be_paid_in_least_subunit ||
      0;
    this.totalPrincipalAmountToBePaid =
      customizableDetails.total_principal_amount_to_be_paid || 0;
    this.totalPrincipalAmountToBePaidInLeastSubunit =
      customizableDetails.total_principal_amount_to_be_paid_in_least_subunit ||
      0;
    this.amountToBePaid = this.minimumDownPaymentAmountToBePaid;
    this.amountToBePaidInLeastSubunit =
      this.minimumDownPaymentAmountToBePaidInLeastSubunit;
  }

  get isEligibleForFreeProduct(): boolean {
    return this.amountToBePaid === 0;
  }
}
